<script>
import Layout from '@layouts/default'
import VehicleSearch from '@components/vehicle-search'

export default {
  page: {
    title:
      'What is a VIN (Vehicle Identification Number)?| AutoCheck | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content:
          'AutoCheck answers "What is a VIN (vehicle identification number)?"',
      },
      {
        name: 'keywords',
        content: 'what is a vin (vehicle identification number)',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/vin-basics',
      },
    ],
  },
  components: { Layout, VehicleSearch },
}
</script>

<template>
  <Layout>
    <div class="row mt-4">
      <div class="col-12 col-md-9">
        <div class="content-page-inner-box"
          ><h1
            ><a name="whatisavin"
              >What is a vehicle identification <br />
              number (VIN)?</a
            ><hr />
          </h1>
          <p
            ><img
              width="608"
              vspace="0"
              hspace="0"
              height="70"
              border="0"
              align="middle"
              alt="VIN Example"
              src="images/what-is-vin.png"
          /></p>
          <p
            >The car's vehicle identification number (VIN) is the identifying
            code for a SPECIFIC automobile. The VIN serves as the car's
            fingerprint, as no two vehicles in operation have the same VIN. A
            VIN is composed of 17 characters (digits and capital letters) that
            act as a unique identifier for the vehicle. A VIN displays the car's
            unique features, specifications and manufacturer. The VIN can be
            used to track recalls, registrations, warranty claims, thefts and
            insurance coverage.</p
          >
          <div class="sectionContent"
            ><h3 class="titleBlue"
              >What if the VIN is not 17 characters long?</h3
            >
            <p
              >Double-check to make sure that you have the right VIN and have
              copied it down correctly. Once you have verified that the VIN is
              definitely less than 17 characters, the VIN is most likely from a
              pre-1981 vehicle.</p
            >
            <p
              >Prior to 1981, VINs varied in length from 11 to 17 characters.
              AutoCheck can only report on vehicles that use a 17 character VIN.
              Therefore, information on vehicles manufactured before 1981 is
              limited.</p
            ></div
          >
          <div id="decode" class="sectionContent"
            ><h3>VIN Decode Explained</h3>
            <hr />
            <h4>What do the numbers and letters in a VIN mean?</h4>
            <p
              >What do the 17 digits in a VIN mean? See the breakdown below of
              the meaning behind each segment of the VIN:</p
            ></div
          >
          <div class="sectionContent"
            ><p
              ><img
                width="100%"
                border="0"
                src="images/vin-decode.jpg"
                alt="VIN decode"
                title="VIN decode"/></p
          ></div>
          <div class="sectionContent"
            ><p>&nbsp;</p>
            <h3><a id="findvin">Where Can I Find the VIN?</a></h3>
            <hr />
            <p style="font-size: 11.8181819915771px;"
              >The VIN can be found by looking at the dashboard on the driver's
              side of the vehicle. The easiest way to view it is to stand
              outside the vehicle on the driver's side and look at the corner of
              the dashboard where it meets the windshield. If the VIN cannot be
              found there, open the driver's side door and look at the door post
              (where the door latches when it is closed). It is likely that the
              VIN will also be displayed in this location. See the image
              below:</p
            >
            <div class="sectionContent" style="font-size: 11.8181819915771px;"
              ><p
                ><img
                  width="100%"
                  border="0"
                  src="images/vin-location.png"
                  alt="how to find the vin number"/></p
            ></div>
            <div class="sectionContent" style="font-size: 11.8181819915771px;"
              ><h4 class="titleBlue"
                >Look for the VIN in these other locations:</h4
              >
              <ul>
                <li>Insurance card/Insurance policy</li>
                <li>Vehicle title and registration</li>
              </ul></div
            >
            <p>&nbsp;</p>
            <p
              >You can obtain a <b>free VIN check</b> by entering it in the VIN
              check box below under "Run an AutoCheck<sup
                style="font-size:10px;"
                >®</sup
              >
              vehicle history report." Enter your VIN in the space provided and
              click "Check VIN." (You can obtain your free VIN check without
              having to purchase anything.)</p
            >
            <p
              >Above the order form, you will be able to view the year, make,
              model, style and country of assembly for your VIN. In addition,
              you will also be told how many vehicle history records there are
              for this vehicle. To view a full vehicle history report, choose
              one of the report options and fill out your information to
              purchase the package you want.</p
            ></div
          ></div
        >
        <VehicleSearch
          title="Vehicle Search: Enter a VIN"
          :toggle="true"
          :search-type="{ vin: true, plate: false }"
        />
      </div>
      <div class="col-12 col-md-3">
        <div class="content-page-right-navigation gray">
          <h4>All About VINs</h4>
          <ul>
            <li
              ><a
                v-scroll-to="'#whatisavin'"
                class="secondary-anchor-link"
                href="#"
                >What is a VIN?</a
              ></li
            >
            <li
              ><a v-scroll-to="'#decode'" class="secondary-anchor-link" href="#"
                >VIN Decode Explained</a
              ></li
            >
            <li
              ><a
                v-scroll-to="'#findvin'"
                class="secondary-anchor-link"
                href="#"
                >Where Can I Find the VIN?</a
              ></li
            >
          </ul>
        </div>
        <div class="mt-4">
          <a v-scroll-to="'#searchVin'" href="#"
            ><img class="w-80 m-auto d-block" src="images/ac-check-vin.png"
          /></a>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
